<template>
    <div class="p-8 md:px-20 md:px-44 lg:px-72 mt-10">
        <div class="grid grid-cols-1">
            <div class="justify-self-center"><img src="../assets/images/404empty.png" alt=""></div>
            <div class="justify-self-center font-bold text-xl mt-5">{{ content }}</div>
        </div>
    </div>
</template>

<script setup>
defineProps(['content'])
</script>